import React, { useState } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  Box,
  Button,
  Flex,
  VStack,
  Link,
  Text,
  useToast,
} from "@chakra-ui/react";
import logo from "../../Assets/logo.png";
import logo1 from "../../Assets/logo1.png";
import bg from "../../Assets/InitBg.png";
import { COLORS } from "../../Helper/Colors";
import DotSpinner from "../../Components/Common/DotSpinner";
import { Form } from "./Login.style";
import {
  useLocation,
  useNavigate,
  useSearchParams,
  Link as ReachLink,
  useParams,
} from "react-router-dom";
import { YEAR } from "../../Helper/Constants";
import Api from "../../Helper/ApiHandler";
import { Eye, EyeSlash } from "phosphor-react";
import { FormInput } from "../../Components/Common/UI";
import { useEffect } from "react";
import { Cookies } from "react-cookie";
import PageLoader from "../../Components/Common/PageLoader";

const ResetPassword = () => {
  const api = new Api();
  const cookies = new Cookies();
  let location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  let navigate = useNavigate();
  let { token } = useParams();
  let toast = useToast();
  const [btnLoading, setBtnLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  let to = location.state?.from || "/dashboard";
  let verifytoken = token.split("~");

  useEffect(() => {
    if (cookies.get("jomtoken")) {
      navigate(to, { replace: true });
    } else {
      api
        .post("auth/verify-token", { token: verifytoken[1] })
        .then((res) => {
          setIsValid(res.status);
          setPageLoading(false);
          return;
        })
        .catch((err) => {
          setIsValid(false);
          setPageLoading(false);
          return;
        });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, to]);

  const initialValues = {
    password: "",
    confirmPassword: "",
  };
  const schema = yup.object().shape({
    password: yup
      .string()
      .required("Password is required!")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
        "Password must contain 8 characters with atleast one uppercase & one special character."
      ),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("password"), null], "Passwords must match.")
      .required("Confirm password is required."),
  });
  const handleFormSubmit = async (values) => {
    try {
      setBtnLoading(true);
      await api.post("auth/reset-password/" + verifytoken[1], {
        password: values.password,
      });
      setBtnLoading(false);
      navigate("/", { replace: true });
      toast({
        description: "Your password has been reset successfully.",
        status: "success",
        duration: 3000,
        isClosable: false,
        position: "top",
      });
    } catch (error) {
      setBtnLoading(false);
      toast({
        description: error.message,
        status: "error",
        duration: 2000,
        isClosable: false,
        position: "top",
      });
    }
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: schema,
    onSubmit: handleFormSubmit,
  });

  const handleChange = (name, value) => {
    formik.setFieldTouched(name, true, true);
    formik.setValues({ ...formik.values, [name]: value });
  };
  const handleConfirmPasswordShow = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleNewPasswordShow = () => {
    setShowPassword((prev) => !prev);
  };
  const { values, touched, errors } = formik;
  return (
    <Flex
      alignItems={{ md: "center" }}
      position="relative"
      h="100vh"
      direction={{ sm: "column", md: "row" }}
    >
      <Text
        position={"absolute"}
        bottom={10}
        left={{ sm: "0", md: "-28%" }}
        fontSize="sm"
        color={{ sm: "brand.900", md: "brand.100" }}
        width={"100%"}
        textAlign={"center"}
      >
        &copy; {YEAR}{" "}
        <Link color="brand.500" href="https://staging.just-one-moment.com/">
          justonemoment.com
        </Link>{" "}
        All Rights Reserved.
      </Text>
      <Box
        flex={{ sm: "0.15", md: "0.8" }}
        height={{ md: "100%" }}
        display={"flex"}
        alignItems={{ sm: "center", md: "center" }}
        justifyContent={"center"}
        backgroundImage={{ md: `url(${bg})` }}
        backgroundSize={"cover"}
        backgroundRepeat={"no-repeat"}
        backgroundColor={COLORS.brandDark}
      >
        <Box display={"flex"} alignItems={"center"}>
          <Box>
            <img src={logo} alt="logo" />
          </Box>
          <Box marginLeft={"20px"}>
            <img src={logo1} alt="logo" />
          </Box>
        </Box>
      </Box>

      <Box position={"relative"} flex={{ sm: "0.65", md: "1" }}>
        <PageLoader isLoading={pageLoading} spinnerColor={null}>
          <Box
            display={"flex"}
            width={"100%"}
            height={"100%"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            {!isValid && (
              <Box
                display="flex"
                flex="1"
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Text fontSize={"2xl"} fontWeight={"bold"} textAlign="start">
                  Reset Password
                </Text>
                <Text
                  fontSize={"lg"}
                  marginY={4}
                  fontWeight={"normal"}
                  color={COLORS.mediumGray}
                  textAlign="center"
                >
                  Your password reset link has been expired.
                </Text>
                <Link
                  as={ReachLink}
                  textAlign={"center"}
                  color="brand.500"
                  to="/forgot-password"
                  fontSize={{ sm: "14px", md: "16px" }}
                  _focus={{}}
                >
                  Click here to send email again to receive the link.
                </Link>
              </Box>
            )}
            {!!isValid && (
              <Form onSubmit={formik.handleSubmit}>
                <VStack spacing={6} align="flex-start">
                  <Text fontSize={"2xl"} fontWeight={"bold"} textAlign="start">
                    Reset Password
                  </Text>
                  <Text fontSize={"1xl"} textAlign="start">
                    You can now reset your password from here.
                  </Text>
                  <FormInput
                    onBlur={formik.handleBlur}
                    type={!showPassword ? "password" : "text"}
                    name="password"
                    label="New Password"
                    placeholder="Enter your new password"
                    value={values.password}
                    error={!!touched.password && errors.password}
                    errorMsg={errors.password}
                    onChange={(e) => handleChange("password", e.target.value)}
                    isRequired={true}
                    rightIcon={
                      !showPassword ? (
                        <Eye
                          color={COLORS.brand}
                          size={24}
                          onClick={handleNewPasswordShow}
                          cursor="pointer"
                        />
                      ) : (
                        <EyeSlash
                          color={COLORS.brand}
                          size={24}
                          onClick={handleNewPasswordShow}
                          cursor="pointer"
                        />
                      )
                    }
                  />
                  <FormInput
                    onBlur={formik.handleBlur}
                    type={!showConfirmPassword ? "password" : "text"}
                    name="confirmPassword"
                    label="Confirm Password"
                    placeholder="Confirm your new password"
                    value={values.confirmPassword}
                    error={!!touched.confirmPassword && errors.confirmPassword}
                    errorMsg={errors.confirmPassword}
                    onChange={(e) =>
                      handleChange("confirmPassword", e.target.value)
                    }
                    isRequired={true}
                    rightIcon={
                      !showConfirmPassword ? (
                        <Eye
                          color={COLORS.brand}
                          size={24}
                          onClick={handleConfirmPasswordShow}
                          cursor="pointer"
                        />
                      ) : (
                        <EyeSlash
                          color={COLORS.brand}
                          size={24}
                          onClick={handleConfirmPasswordShow}
                          cursor="pointer"
                        />
                      )
                    }
                  />
                  <Button
                    isLoading={btnLoading}
                    spinner={
                      <DotSpinner key={"login"} color={"#fff"} size={8} />
                    }
                    type="submit"
                    colorScheme="brand"
                    className="custom-btn"
                    size={"lg"}
                    marginTop={"35px !important"}
                    isFullWidth
                  >
                    Reset
                  </Button>
                </VStack>
              </Form>
            )}
          </Box>
        </PageLoader>
      </Box>
    </Flex>
  );
};

export default ResetPassword;
